import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../../Navbar/Navbar";
import { Link } from "react-router-dom";
import baseURL from "../../config";
import { Box, Button, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { FaPlus, FaEye } from "react-icons/fa";
import PeopleIcon from "@mui/icons-material/People";
import CircularProgress from '@mui/material/CircularProgress';

const VesselManagerTable = () => {
  const [vesselManagers, setVesselManagers] = useState([]);
  const [selectedManager, setSelectedManager] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true); 

  useEffect(() => {
    const token = localStorage.getItem("token"); // or from context, session, etc.
    setIsLoading(true);
  
    axios
      .get(`${baseURL}/api/getvesselManager`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setVesselManagers(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
       setError(error?.response?.data?.message);
  });
  }, []);
  
  // Open View Details Dialog
  const handleViewDetails = (manager) => {
    setSelectedManager(manager);
  };

  // Close View Details Dialog
  const handleCloseDetails = () => {
    setSelectedManager(null);
  };

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '16rem',
        }}
      >
        <CircularProgress color="primary" size={60} thickness={5} />
      </Box>
    );
  }

  return (
    <>
      <Navbar />
       {/* Error message */}
          {error && (
            <Box p={4} textAlign="center" bgcolor="#fdecea" color="#b71c1c">
              <Typography color="error" variant="h6">
                {error}
              </Typography>
            </Box>
          )}

      <Box p={4}>
        {/* Title & Buttons Section */}
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={3}>
          {/* Left Side: User List Button */}
          <Link to="/user-list" style={{ textDecoration: "none" }}>
            <Button variant="contained" color="secondary" startIcon={<PeopleIcon />}>
              User List
            </Button>
          </Link>
          <Link to="/set-permissions" style={{ textDecoration: "none" }}
>
            <Button variant="contained" color="secondary" startIcon={<PeopleIcon />}>
              Set Permissions
            </Button>
          </Link>

          {/* Center: Title */}
          <Typography variant="h5" sx={{ display: "flex", alignItems: "center" }}>
            <PeopleIcon sx={{ marginRight: 1, color: "#007bff" }} />
            Vessel Manager Table
          </Typography>

          {/* Right Side: Add Buttons */}
          <Box display="flex" gap={2}>
            <Link to="/adminSignup" style={{ textDecoration: "none" }}>
              <Button variant="contained" color="primary" startIcon={<FaPlus />}>
                Admin Signup
              </Button>
            </Link>
            <Link to="/VesselMangerForm" style={{ textDecoration: "none" }}>
              <Button variant="contained" color="primary" startIcon={<FaPlus />}>
                Add Vessel Manager
              </Button>
            </Link>
          </Box>
        </Box>

        {/* Table Section */}
        <Paper elevation={3} sx={{ borderRadius: 2 }}>
          <TableContainer >
            <Table>
              <TableHead sx={{ backgroundColor: "#1976D2", height: "30px" }}>
                <TableRow>
                  <TableCell sx={{ padding: "12px", color: "white", fontWeight: "bold", width: "100px" }}>
                    <Typography variant="h6">Sr. No.</Typography>
                  </TableCell>
                  <TableCell sx={{ padding: "12px", color: "white", fontWeight: "bold" }}>
                    <Typography variant="h6">Company Details</Typography>
                  </TableCell>
                  <TableCell sx={{ padding: "12px", color: "white", fontWeight: "bold" }}>
                    <Typography variant="h6">Actions</Typography>
                  </TableCell>
                </TableRow>

              </TableHead>
              <TableBody>
                {vesselManagers.map((manager, index) => (
                  <TableRow key={manager._id}>
                    {/* Company Details Column */}
                    <TableCell style={{ width: "50px" }}>{index + 1}</TableCell>
                    <TableCell>
                      <Typography variant="body1"><strong>Company Name:</strong> {manager.companyName}</Typography>
                      <Typography variant="body2"><strong>Short Name:</strong> {manager.companyShortName}</Typography>
                      <Typography variant="body2"><strong>Phone:</strong> {manager.phoneNumber}</Typography>
                      <Typography variant="body2"><strong>Email:</strong> {manager.email}</Typography>
                    </TableCell>

                    {/* Actions Column */}
                    <TableCell>
                      <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<FaEye />}
                        onClick={() => handleViewDetails(manager)}
                      >
                        View Details
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>

      {/* View Details Dialog with Table Format */}
      {selectedManager && (
        <Dialog open={!!selectedManager} onClose={handleCloseDetails} maxWidth="md" fullWidth>
          <DialogTitle sx={{ textAlign: "center", backgroundColor: "#3f51b5", color: "#fff", padding: "16px" }}>
            Vessel Manager Details
          </DialogTitle>
          <DialogContent sx={{ padding: "16px" }}>
            <TableContainer component={Paper}>
              <Table>
                <TableBody>

                  {/* Company Details */}
                  <TableRow>
                    <TableCell colSpan={2}>
                      <Typography variant="h6" color="primary">Company Details</Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Company Name:</strong></TableCell>
                    <TableCell>{selectedManager.companyName}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Short Name:</strong></TableCell>
                    <TableCell>{selectedManager.companyShortName}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Phone:</strong></TableCell>
                    <TableCell>{selectedManager.phoneNumber}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Email:</strong></TableCell>
                    <TableCell>{selectedManager.email}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Address:</strong></TableCell>
                    <TableCell>{selectedManager.address}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Document:</strong></TableCell>
                    <TableCell>
                      {selectedManager.companyDocument?.filePath ? (
                        <a href={selectedManager.companyDocument.filePath} target="_blank" rel="noopener noreferrer">
                          {selectedManager.companyDocument.originalName}
                        </a>
                      ) : "No Documents Available"}
                    </TableCell>
                  </TableRow>

                  {/* Crewing Details */}
                  <TableRow>
                    <TableCell colSpan={2}>
                      <Typography variant="h6" color="primary">Crewing Details</Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Title:</strong></TableCell>
                    <TableCell>{selectedManager.crewingTitle}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Person Name:</strong></TableCell>
                    <TableCell>{selectedManager.crewingPersonName}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Phone:</strong></TableCell>
                    <TableCell>{selectedManager.crewingPhoneNumber}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Email:</strong></TableCell>
                    <TableCell>{selectedManager.crewingEmail}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Date:</strong></TableCell>
                    <TableCell>{new Date(selectedManager.crewingDate).toLocaleDateString()}</TableCell>
                  </TableRow>

                  {/* Accounts Details */}
                  <TableRow>
                    <TableCell colSpan={2}>
                      <Typography variant="h6" color="primary">Accounts Details</Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Title:</strong></TableCell>
                    <TableCell>{selectedManager.accountsTitle}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Person Name:</strong></TableCell>
                    <TableCell>{selectedManager.accountsPersonName}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Phone:</strong></TableCell>
                    <TableCell>{selectedManager.accountsPhoneNumber}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><strong>Email:</strong></TableCell>
                    <TableCell>{selectedManager.accountsEmail}</TableCell>
                  </TableRow>

                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDetails} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default VesselManagerTable;
